import './index.scss'
import { useEffect, useState } from 'react'
import { IPurchaseOrder } from '@/types/purchaseOrder.types';
import { getPurchaseOrderById } from '@/common/services/purchaseOrder.api';
import { useParams } from 'react-router-dom';
import { getPurchaseReturnsByPurcahseOrderId } from '@/common/services/purchase-return.api';
import { IPurchaseReturn } from '@/types/purchase-return.type';
import Loading from '@/common/components/ui/loading/Loading';
import { COMPANIES } from '@/common/helpers/company.helpers';

export function PurchaseReturnDashboard() {

  const [purchaseOrder, setPurchaseOrder] = useState<IPurchaseOrder>();
  const [purchaseReturn, setPurchaseReturn] = useState<IPurchaseReturn>();
  const [loading, setIsLoading] = useState(true);

  const { purchaseReturnId } = useParams();

  const freezeTime = function (cb: () => void, seconds: number) {
    return new Promise((resolve) => {

      setTimeout(() => {
        cb();
        resolve(true);
      }, seconds * 1000);
    })
  }

  useEffect(() => {
    async function loadPurchaseOrder() {
      const res = await getPurchaseOrderById(purchaseReturnId as string);

      setPurchaseOrder(res.data);

      const res2 = await getPurchaseReturnsByPurcahseOrderId(res.data._id as string);
      setPurchaseReturn(res2.data);
      freezeTime(() => setIsLoading(false), 1);
    }
    loadPurchaseOrder();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='contentInfoPurchaseReturn'>
        <h1 className='text-3xl font-semibold mb-2'>Descrição da Solicitação de Devolução</h1>
      
      {loading && <Loading></Loading>}

      {!loading && < div className="containerInfoPurchaseReturn">

        <div className="contentItens">
          <h2 className='text-xl font-semibold mb-2'>Todos os itens devolvidos</h2>
          <div className="space-y-6">
            {purchaseReturn?.products.map((item, i) => (
              <div key={i} className="p-4 border rounded">
                <p className="break-words font-semibold mb-2">Item: {item.description}</p>
                <p><strong>Quantidade:</strong> {String(item.qtd)}</p>
                <p><strong>Preço Unitário:</strong> {item.value}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="purchaseReturnInfo">
          <h2 className='text-xl font-semibold mb-3'>Informações da devolução</h2>
          <label className='font-semibold'>Descrição da compra:</label>
          <p className="info-field break-words font-semibold mb-4">Item: {purchaseReturn?.purchaseOrderDescription}</p>

          <label className='font-semibold'>Código da OC:</label>
          <p className="info-field break-words font-semibold mb-4">Código: {purchaseOrder?.code}</p>

          <label className='font-semibold'>Cidade:</label>
          <p className="info-field break-words font-semibold mb-4">{COMPANIES[purchaseOrder?.companyId as string]?.name}</p>

          <label className='font-semibold'>Solicitante:</label>
          <p className="info-field break-words font-semibold mb-4">{purchaseOrder?.requestorName}</p>

          <label className='font-semibold'>Data:</label>
          <p className="info-field break-words font-semibold mb-4">{new Date(purchaseOrder?.createdAt as Date).toLocaleDateString("pt-BR")}</p>
        </div>
      </div >}
    </div>
  )
}